import React, { createContext, useContext } from 'react';

const EnquiryContext = createContext(null);

export const useEnquiry = () => {
  const context = useContext(EnquiryContext);
  if (!context) {
    throw new Error('useEnquiry must be used within an EnquiryProvider');
  }
  return context;
};

export const EnquiryProvider = ({ children, value: externalValue }) => {
  return (
    <EnquiryContext.Provider value={externalValue}>
      {children}
    </EnquiryContext.Provider>
  );
};

export default EnquiryContext;